<template>
  <el-form v-model="credentials" class="login-form" >
    <el-form-item label="Adresse Email" >
      <el-input
         v-model="credentials.login"
         type="email"
         placeholder="Email"
         @keyup.native.enter="login" >
      </el-input>
    </el-form-item>
    <el-form-item label="Mot de passe" >
      <el-input
         v-model="credentials.password"
         type="password"
         placeholder="Password"
         @keyup.native.enter="login" >
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="login" icon="el-icon-fa-sign-in" >
        Se connecter
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
 export default {
   data () {
     return {
       credentials: {
         login: '',
         password: ''
       }
     }
   },
   methods: {
     login () {
       if (this.credentials.login && this.credentials.password) {
         this.$store.dispatch('login', this.credentials).then(() => {
           this.$router.push('/')
         }).catch(err => {
           if (!err.quiet) {
             this.$notify.error({
               title: 'Authentification échouée',
               message: 'Adresse email ou mot de passe incorrect'
             })
           }
         })
       }
     }
   }
 }
</script>



// WEBPACK FOOTER //
// node_modules/macarons/src/components/Login.vue